

export const berufeList = [
    {key: 'ausbildung', label: 'Diese Berufe bilden wir aus (m/w/d)'},
    {key: 'studium', label: 'Diese Studiengänge bieten wir an (m/w/d)'},
    {key: 'ausbildungdual', label: 'Diese Berufe bilden wir als dualer Partner aus (m/w/d)'},
    {key: 'bildungsweg', label: 'Diese Bildungswege bieten wir an (m/w/d)'},
    {key: 'praktikum', label: 'Diese Praktikumsplätze bieten wir an (m/w/d)'},
    {key: 'schulischeausbildung', label: 'Diese Berufe bilden wir in unserer Schule aus (m/w/d)'},
]